export default __webpack_public_path__ + "static/media/eb-pro-blk-poster-3.1ed2a8c1.jpg";